import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import Room from '../Classes/ClvrRoom'
import { RoomDto } from '../Types/RoomDto'
import { get } from 'lodash'

export class RoomApiAdapter implements ApiDataAdapter<Room> {
    public createClass(apiData: RoomDto): Room {
        return new Room({
            id: get(apiData, 'id'),
            roomOperationId: get(apiData, 'bloc_id'),
            name: get(apiData, 'nom'),
            alias: get(apiData, 'alias'),
            stats: get(apiData, 'stats'),
            dh: get(apiData, 'dh'),
            checklistMan: get(apiData, 'cheklist_man'),
            color: get(apiData, 'color'),
            active: get(apiData, 'actif'),
            code: get(apiData, 'code'),
            checklistDefaultId: get(apiData, 'checklist_default_id'),
            checklistDefaultHas: get(apiData, 'checklist_default_has'),
            opConditionalAccess: get(apiData, 'op_conditional_access'),
        })
    }
}
